<template>
  <div class="dashboard__container_a">
    <div class="dashboard__info warning_mess">
      <div v-if="subscriptionData?.messages_available === 0" class="dashboard__info-ready warning_mess">
        <div class="dashboard__info-text warning_mess">
          Your chatbot run out of messages!
        </div>
        <div class="dashboard__info-desc warning_mess">
          Please upgrade your plan to continue to use messages
        </div>
        <router-link
          to="/user/billing"
          class="dashboard-info__try-demo-link warning_mess"
          >Upgrade plan</router-link
        >
      </div>
    </div>
    <div class="dashboard__title-wrapper">
      <h2 class="dashboard__title">Dashboard</h2>
      <svg v-if="isSubscribed" class="sub-icon">
        <use href="../../assets/icons/subscribed2.svg#subscribed"></use>
      </svg>
    </div>

    <ul v-if="widget" class="analytic__list">
      <li class="analytic__list-item">
        <div class="item__top-wrapper">
          <div>
            <img src="@/assets/img/analytic_link.svg" alt="chat" />
          </div>
          <p class="item__title">Total Links</p>
        </div>
        <p class="item__value">
          {{ widget.linksCount }}
        </p>
        <router-link to="links" class="item__link">
          View all links
        </router-link>
      </li>

      <li v-if="widget.textCount > 0" class="analytic__list-item">
        <div class="item__top-wrapper">
          <div>
            <img src="@/assets/img/analytic_uprock.svg" alt="chat" />
          </div>
          <p class="item__title">Total Texts</p>
        </div>
        <p class="item__value">
          {{ widget.textCount }}
        </p>
        <router-link to="text" class="item__link">View all texts </router-link>
      </li>

      <li v-if="widget.googleCount > 0" class="analytic__list-item">
        <div class="item__top-wrapper">
          <div>
            <img src="@/assets/img/analytic_uprock.svg" alt="chat" />
          </div>
          <p class="item__title">Total GoogleDoc Files</p>
        </div>
        <p class="item__value">
          {{ widget.googleCount }}
        </p>
        <router-link to="google" class="item__link">
          View all GoogleDoc files
        </router-link>
      </li>
      <li class="analytic__list-item">
        <div class="item__top-wrapper">
          <div>
            <img src="@/assets/img/analytic_chat.svg" alt="chat" />
          </div>
          <p class="item__title">Total Conversations</p>
        </div>
        <p class="item__value">
          {{ widget.totalConversations }}
        </p>
        <router-link to="chat_history" class="item__link">
          View all conversations
        </router-link>
      </li>
      <li class="analytic__list-item">
        <div class="item__top-wrapper">
          <div>
            <img src="@/assets/img/analytic_warn.svg" alt="chat" />
          </div>
          <p class="item__title">Avg. Messages</p>
        </div>
        <p class="item__value">
          {{ widget.avgMessages.toFixed() }}
        </p>
      </li>
      <!-- <li class="analytic__list-item">
        <div class="item__top-wrapper">
          <div>
            <img src="@/assets/img/analytic_like.svg" alt="chat" />
          </div>
          <p class="item__title">
            Positive feedback
          </p>
        </div>
        <p class="item__value">
          0%
        </p>
        <a class="item__link">
          View all links
        </a>
      </li>
      <li class="analytic__list-item">
        <div class="item__top-wrapper">
          <div>
            <img src="@/assets/img/analytic_dislike.svg" alt="chat" />
          </div>
          <p class="item__title">
            Negative feedback
          </p>
        </div>
        <p class="item__value">
          0%
        </p>
        <a class="item__link">
          View all links
        </a>
      </li> -->
    </ul>
    <!-- <div class="dashboard__info">
      <h3 class="dashboard__info-title">Embed chatbot</h3>
      <div class="dashboard__info-ready">
        <div class="dashboard__info-text">Your chatbot is now ready!</div>
        <div class="dashboard__info-desc">
          Your chatbot is now published and ready to be shared with the world!
          Copy this link to share your chatbot on the website.
        </div>
        <router-link to="/user/demo" class="dashboard-info__try-demo-link">Try demo</router-link>
      </div>
    </div> -->
    <h3 class="dashboard__info-title">Embed your chatbot on your website</h3>
    <p class="dashboard__info-desc second">
      You can embed your chatbot on the website. Copy the code below and paste
      it in your website code.
    </p>
    <div class="chatbot-link__wrapper">
      <InputWebsite
        id="script"
        class="analytic_ready_input"
        :value="botScript"
      />
      <ButtonWithLoadWebsite @onClick="copyScript" title="Copy" />
    </div>
  </div>
</template>

<script>
import ButtonWithLoadWebsite from "../../components/shared/ButtonWithLoadWebsite.vue";
import InputWebsite from "../../components/shared/InputWebsite.vue";
import store from "../../vuex/store";
const VUE_APP_IMAGES = process.env.VUE_APP_IMAGES;

export default {
  components: {
    InputWebsite,
    ButtonWithLoadWebsite,
  },
  data() {
    return {
      // widget: computed(() => store.getters.getChosen),
      // icons: [
      //   {
      //     image: require("@/assets/img/analytic_link.svg"),
      //     text: "Total Links",
      //     summ: 1,
      //     links: "View all links",
      //   },
      //   {
      //     image: require("@/assets/img/analytic_uprock.svg"),
      //     text: "Total Files",
      //     summ: 40,
      //     links: "View all files",
      //   },
      //   {
      //     image: require("@/assets/img/analytic_chat.svg"),
      //     text: "Total Conversations",
      //     summ: 5,
      //     links: "View all conversations",
      //   },
      //   {
      //     image: require("@/assets/img/analytic_warn.svg"),
      //     text: "Avg. Messages",
      //     summ: 45,
      //     links: "",
      //   },
      //   {
      //     image: require("@/assets/img/analytic_like.svg"),
      //     text: "Positive feedback",
      //     summ: 15,
      //     links: "",
      //   },
      //   {
      //     image: require("@/assets/img/analytic_dislike.svg"),
      //     text: "Negative feedback",
      //     summ: 5.4,
      //     links: "",
      //   },
      // ],
      // placeholder: "Array.prototype.forEach.call(links, function (link)",
    };
  },
  computed: {
    botScript() {
      if (!this.widget) {
        return;
      }
      return `<script async src="${VUE_APP_IMAGES}widget/widget.js" token="${this.widget?.token}"><\/script>`;
    },
    widget() {
      return store.getters.getChosen;
    },
    subscriptionData() {
      return store?.state?.users?.chosenWidget?.owner?.subscription;
    },
    isSubscribed() {
      return (
        this.widget?.subscription?.status === "active" ||
        this.widget?.subscription?.status === "trialing"
      );
    },
  },
  methods: {
    async copyScript() {
      try {
        await navigator.clipboard.writeText(this.botScript);
        this.$toast.success("Script copied");
        gtag("event", "dashboard_widget_script_copied", {});
        amplitude.getInstance().logEvent('dashboard_widget_script_copied', {});
      } catch (e) {
        console.log(error);
        this.$toast.error(
          error?.response?.data?.errorDescription || "Copy script error"
        );
      }
    },
  },
};
</script>

<style scoped lang="scss">
.dashboard__container_a {
  font-family: "Inter", sans-serif;
  min-height: 100%;
  /* height: fit-content; */
}

.dashboard__title-wrapper {
  display: flex;
  gap: 30px;
  align-items: center;
  margin-bottom: 16px;
}

.dashboard__title {
  font-family: inherit;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  color: #4f4f4f;
}

.sub-icon {
  width: 30px;
  height: 30px;
  fill: #3056d3;
}

.analytic__list {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 14px;
  padding: 0;
  margin-bottom: 32px;
  max-width: 869px;

  @media (min-width: 339px) {
    flex-direction: row;
  }
}

.analytic__list-item {
  display: flex;
  width: 255px;
  height: 156px;
  padding: 32px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid #e3e8ef;
  background-color: #fff;
}

.item__top-wrapper {
  display: flex;
  gap: 6px;
  align-items: center;
}

.item__title {
  font-family: inherit;
  margin: 0;
  color: #637381;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.item__value {
  font-family: inherit;
  margin: 0;
  color: #3e3e3e;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}

a.item__link {
  font-family: inherit;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  color: #3056d3;
}

.dashboard__info-title {
  font-family: "Inter", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  color: #4f4f4f;
  margin-bottom: 16px;
}

.dashboard__info-ready {
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  border-radius: 8px;
  border: 1px dashed #27ae60;
  background: #e4fff0;
  max-width: 700px;
  margin-bottom: 32px;
}

.dashboard__info-text.warning_mess {
  color: #ff0000;
  font-weight: 700;
}

.dashboard__info-ready.warning_mess {
  border: 1px dashed #ff0000;
  background: #ffe4e4;
  max-width: 478px;
}

.dashboard__info-desc.warning_mess {
  color: #ff0000;
}

.dashboard__info-desc {
  font-family: "Inter", sans-serif;
  color: #27ae60;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.dashboard__info-desc.second {
  font-size: 14px;
  color: #637381;
  margin-bottom: 8px;
}

.dashboard-info__try-demo-link {
  color: #3e3e3e;
  text-align: center;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
  text-decoration-line: underline;
  transition: all 150ms linear;

  &:hover,
  :focus-visible {
    color: #3056d3;
  }
}

.chatbot-link__wrapper {
  display: flex;
  gap: 24px;

  :deep(.inputWrapper) {
    width: 100%;
  }
  :deep(input) {
    max-width: 100% !important;
  }
}
</style>
